import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_NAME = "Arnold Bookkeeping, LLC";

export const ROUTE_META = {
  "/": {
    title: "Arnold Bookkeeping LLC",
    description:
      "Arnold Bookkeeping provides bookkeeping services and tax prep for small businesses in Wellsville and across Central Pennsylvania — accurate books, fewer surprises.",
  },
  "/services": {
    title: "Arnold Bookkeeping LLC",
    description:
      "Monthly bookkeeping, reconciliation, transaction categorization, financial reporting, and catch-up or cleanup bookkeeping for Pennsylvania small businesses.",
  },
  "/tax-services": {
    title: "Arnold Bookkeeping LLC",
    description:
      "Practical tax preparation and filing for individuals and small businesses — federal, Pennsylvania, and local returns, estimated taxes, and depreciation.",
  },
  "/pricing": {
    title: "Arnold Bookkeeping LLC",
    description:
      "Pricing is based on what your business actually needs — not a predetermined package. See what affects the cost of bookkeeping in 2026.",
  },
  "/industries": {
    title: "Arnold Bookkeeping LLC",
    description:
      "Bookkeeping and tax for trades and construction, real estate, professional services, retail, churches, manufacturing, and trucking across Pennsylvania.",
  },
  "/our-story": {
    title: "Arnold Bookkeeping LLC",
    description:
      "Arnold Bookkeeping was built on a simple idea: small-business owners deserve financial information they can actually understand and use.",
  },
  "/faq": {
    title: "Arnold Bookkeeping LLC",
    description:
      "Answers about bookkeeping costs, tax preparation, QuickBooks, catch-up work, and how Arnold Bookkeeping serves Wellsville and Central Pennsylvania.",
  },
  "/contact": {
    title: "Arnold Bookkeeping LLC",
    description:
      "Have a question or interested in working with Arnold Bookkeeping? Reach out directly or complete the short form — you'll hear back from Aaron Arnold.",
  },
};

function upsert(attr, key, attrValue, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = ROUTE_META[pathname] || ROUTE_META["/"];
    const canonicalPath = pathname in ROUTE_META ? (pathname === "/" ? "/" : pathname) : "/";
    const canonicalUrl = `https://arnoldbookkeeping.com${canonicalPath}`;
    document.title = meta.title;
    upsert("name", "description", "", meta.description);
    upsert("property", "og:title", "", meta.title);
    upsert("property", "og:description", "", meta.description);
    upsert("property", "og:type", "", "website");
    upsert("property", "og:site_name", "", SITE_NAME);
    upsert("property", "og:url", "", canonicalUrl);
    upsert("name", "twitter:card", "", "summary");
    upsert("name", "twitter:title", "", meta.title);
    upsert("name", "twitter:description", "", meta.description);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalUrl);
  }, [pathname]);

  return null;
}
